import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Box,
  useColorMode,
  Icon,
  Divider,
  Text,
} from '@chakra-ui/react'
import { Settings } from 'lucide-react'
import { SecurityConfig } from '@/pages/HomePage/components/SecurityConfig'
import { PasscodeConfig } from '@/pages/HomePage/components/PasscodeConfig'
import type { SecurityOptions, PasscodeOptions } from '@/types/share'

interface SettingsModalProps {
  isOpen: boolean
  onClose: () => void
  securityOptions: SecurityOptions
  onSecurityOptionsChange: (options: SecurityOptions) => void
  passcodeOptions: PasscodeOptions
  onPasscodeOptionsChange: (options: PasscodeOptions) => void
  tier?: 'free' | 'starter' | 'pro'
}

export function SettingsModal({
  isOpen,
  onClose,
  securityOptions,
  onSecurityOptionsChange,
  passcodeOptions,
  onPasscodeOptionsChange,
  tier = 'free',
}: SettingsModalProps) {
  const { colorMode } = useColorMode()

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg={colorMode === 'dark' ? 'stone.800' : 'white'}>
        <ModalHeader display="flex" alignItems="center" gap={2}>
          <Icon as={Settings} boxSize={5} />
          Share Settings Defaults
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={6} align="stretch">
            {/* Passcode config */}
            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={3}>
                Privacy
              </Text>
              <PasscodeConfig
                options={passcodeOptions}
                onChange={onPasscodeOptionsChange}
                tier={tier}
              />
            </Box>

            <Divider />

            {/* Security config */}
            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={3}>
                Security Options
              </Text>
              <SecurityConfig
                options={securityOptions}
                onChange={onSecurityOptionsChange}
                isPublic={passcodeOptions.isPublic}
                tier={tier}
              />
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
